module.exports = __webpack_public_path__ + "img/panowind.80e0de83.jpg";